import BackButton from '../../BackButton/BackButton';
import { Container } from '../../Container/Container';
import Brands from '../HomePage/components/Brands/Brands';
import Print from '../ProductPage/Print';
import styles from './BrandsPage.module.scss';
import { useGetBrands } from '../../../queries/brands/useGetBrands';

export const BrandsPage = () => {
  const { brandsData } = useGetBrands({
    'where[isActive][equals]': 'true',
  });
  return (
    <div className={styles.BrandsPage}>
      <Container>
        <BackButton />
        <h1 className={styles.title}>Наши бренды</h1>
        <p className={styles.description}>
          Groupe SEB объединяет ведущие мировые бренды, предлагая качественную
          технику для дома и кухни. Выберите бренд, чтобы узнать больше о его
          продукции.
        </p>
        <div className={styles.brands}>
          {brandsData && brandsData.docs.length ? (
            <Brands
              data={brandsData.docs.map((item) => {
                return {
                  name: item.name,
                  image: item.image,
                  link: item.link,
                  description: item.description,
                };
              })}
              withTitle={false}
              className={styles.brands_holder}
              classNameItem={styles.brands_item}
            />
          ) : null}
        </div>

        <div className={styles.download_catalog}>
          <span>Инструменты SEB для ремонта и сервисного обслуживания</span>
          <span>
            <Print />
            <a
              href="https://6e8ee6a6-c00b-40bb-a4ec-44a1c22bfeef.selstorage.ru/5aaa669e-9d46-4d24-a023-a3296c90bbb2.pdf"
              target="_blank"
              rel="noreferrer"
              className={styles.link}
            >
              Каталог.pdf
            </a>{' '}
            (672 КБ)
          </span>
        </div>
      </Container>
    </div>
  );
};
